<template>


  <div class="flex w-full h-full mx-auto p-6">

    <div class="vld-parent">
        <loading :active.sync="isLoading" 
        :is-full-page="fullPage"></loading>
    </div>

    <div class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-48 px-4 overflow-hidden">
      <div class="flex items-center pb-4">
        <h3
          class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider"
        >
          Lista de registros
          <span
            class="rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"
          >{{filteredPlaces.length}}</span>
        </h3>

        <!-- <button
              v-on:click="onexportAll()"
              class="bg-transparent hover:bg-cdmx-blue-light text-cdmx-blue-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-cdmx-blue-dark hover:border-transparent rounded"
        >Exportar a excel</button>
-->

        <BaseButton
          @click="onexportAll()"
          variant="primary" 
          icon="download"
          outline
          class="mr-1" 
        >
          Excel
        </BaseButton>
        <BaseButton
          id="downSHP"
          @click="toSHPFileMultiple()"
          variant="info"  
          icon="file-archive"
          outline
          class="mr-1" 
        >
          ZIP ({{ selectedPlaces.length }})
        </BaseButton>

      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de registros"
        class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />
      <div class="w-full">
        <div class="w-full relative mb-2">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="status"
            id="status"
            v-model="categoryFilter"
          >
            <option selected value="-1">Todos</option>
            <template v-for="category in placeCategories">
              <option :key="category.id" :value="category.id">{{category.nombre}}</option>
            </template>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="h-full overflow-auto">
        <div
          v-for="place in filteredPlaces"
          :key="place.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{ 'bg-cdmx-blue-light': place.id === currentPlace.id }"
          @click="selectPlace(place)"
        >
          <!-- Checkbox -->
          <input
            type="checkbox"
            class="mr-3 h-4 w-4 cursor-pointer"
            :checked="selectedPlaces.includes(place.id)"
            @click.stop
            @change="togglePlace(place.id)"
          />

          <!-- Texto -->
          <div class="flex w-5/6 flex-col ml-2">
            <span
              :class="place.id === currentPlace.id ? 'text-gray-100' : 'text-gray-900'"
              class="group-hover:text-gray-900"
            >
              {{ place.nombre }}
            </span>

            <span
              :class="place.id === currentPlace.id ? 'text-gray-300' : 'text-gray-700'"
              class="text-sm group-hover:text-gray-700"
            >
              {{ place.proyecto_nombre }}
            </span>
          </div>
        </div>
      </div>

    </div>
    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full" v-if="is_selected" >
          <div class="w-full pb-2 text-right">
            <BaseButton
              id="downGeojson"
              @click="toGeojsonFile()"
              variant="info"
              icon="file-alt"
              outline
              class="mr-1"
            >
                Geojson
            </BaseButton>

            <BaseButton
              id="downKML"
              @click="toKMLFile()"
              variant="info"
              icon="file-alt"
              outline
              class="mr-1"
            >
                KML
            </BaseButton> 

            <BaseButton
              id="downSHP"
              @click="toSHPFile()"
              variant="info"
              icon="file-archive"
              outline
              class="mr-1"
            >
                Shapefile (zip)
            </BaseButton> 

            <BaseButton
              @click="onexport()"
              variant="primary"
              icon="download"
              outline
              class="mr-1"
            >
                Exportar
            </BaseButton>

            <BaseButton
              v-if="is_editable"
              @click="openEditModal()"
              variant="info"
              icon="pen"
              outline
              class="mr-1"
            >
                Editar
            </BaseButton>

            <BaseButton
              v-if="is_editable"
              @click="showingConfirm = true"
              variant="danger"
              icon="trash-alt"
              outline 
            >
                Eliminar
            </BaseButton>
          </div>
          <div class="flex">
            <div class="h-80 w-full">
              <l-map
                ref="map"
                class="h-full w-full z-0"
                :zoom="zoom"
                :minZoom="minZoom"
                :maxZoom="maxZoom"
                :center="center"
                :options="{zoomControl: false}"
                @ready="onMapReady"
              > 
                <l-tile-layer :url="urlBaseMap" :attribution="attribution"></l-tile-layer>
              </l-map>
            </div>
          </div>
          <div class="flex py-2">
            <div class="w-full px-4 text-left">
             <div class="font-bold tracking-wide text-lg text-gray-900">{{ currentPlace.nombre }}</div>
              <div
                class="text-sm text-gray-700"
                v-html="removeLineBreaks(this.currentPlace.descripcion)"
              ></div> 


              <br>
              <p>
                <span class="font-bold">Proyecto: </span>
                <span class="text-sm">{{ currentPlace.proyecto_nombre }}</span> 
              </p>

              <p>
                <span class="font-bold">Categoría: </span>
                <span class="text-sm">{{ currentPlace.cat_principal_nombre }}</span> 
              </p>    

              <p>
                <span class="font-bold">Tipo: </span>
                <span class="text-sm">{{ currentPlace.tipo_nombre }}</span> 
              </p>   

              <p>
                <span class="font-bold">Subcategoría: </span>
                <span class="text-sm">{{ currentPlace.cat_secundaria_nombre }}</span> 
              </p>       

              <p>
                <span class="font-bold">Fecha: </span>
                <span class="text-sm">{{ currentPlace.fecha_levantamiento | moment("DD/MM/YYYY hh:mm a") }}</span>
              </p>

              <p>
                <span class="font-bold">Visualización: </span>
                <span v-if = "currentPlace.privado == false" class="text-sm">Público</span> 
                <span v-else-if = "currentPlace.privado == true" class="text-sm">Privado</span>
                <span v-else class="text-sm"> </span>
              </p>

              <p>
                <span class="font-bold">Método de registro: </span>
                <span class="text-sm">{{ currentPlace.geosource }}</span>
              </p>    

              <p>
                <span class="font-bold">Subido por: </span>
                <span class="text-sm">{{ currentPlace.usuario }}</span> 
              </p>

              <p>
                <span class="font-bold">Tipo de geometría: </span>
                <span class="text-sm">{{ this.geom_type }}</span> 
              </p>

              <p>
                <span class="font-bold">Coordenadas: </span>
                <span class="text-sm">{{ this.geom_coords }}</span> 
              </p>

              <p>
                <span class="font-bold">Longitud: </span>
                <span class="text-sm">{{ this.geom_length }}</span> 
              </p>  

              <p>
                <span class="font-bold">Superficie (área): </span>
                <span class="text-sm">{{ this.geom_area }}</span> 
              </p>

              <p>
                <span class="font-bold">Altitud: </span>
                <span class="text-sm">{{ currentPlace.altitud }}</span> 
              </p>   

              <br>
              <br>

                    

              <div v-if="this.currentPlace.media_folder != null && this.currentPlace.file_type != 'audio/mpeg'">


                  <div class="relative flex flex-col text-left px-4">
    <!--                 <span class="font-bold text-gray-700">Fecha de registro:</span>
                    <div v-html="formatDate(currentPlace.fecha_levantamiento)"></div> -->
                    <span class="font-bold text-gray-700">Fecha de imagen/video:</span>
                    <div
                      v-html="dateMediaFile(currentPlace.media_metadata, currentPlace.file_type)"
                    ></div>
    <!--                 <span
                      v-if="datesDontMatch(currentPlace.fecha_levantamiento, currentPlace.media_metadata, currentPlace.file_type) == true"
                      class="text-cdmx-red italic"
                    >Las fechas de registro y de archivo de media no coinciden</span> -->
                    <button
                      class="absolute top-0 right-0 border-2 rounded border-gray-700"
                      @click="openMetadataModal()"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        enable-background="new 0 0 24 24"
                        class="h-6 w-6 fill-current"
                        viewBox="0 0 24 24"
                      >
                        <g>
                          <rect fill="none" height="24" width="24" />
                          <path
                            d="M19,7H9C7.9,7,7,7.9,7,9v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V9C21,7.9,20.1,7,19,7z M19,9v2H9V9H19z M13,15v-2h2v2H13z M15,17v2h-2v-2H15z M11,15H9v-2h2V15z M17,13h2v2h-2V13z M9,17h2v2H9V17z M17,19v-2h2v2H17z M6,17H5c-1.1,0-2-0.9-2-2V5 c0-1.1,0.9-2,2-2h10c1.1,0,2,0.9,2,2v1h-2V5H5v10h1V17z"
                          />
                        </g>
                      </svg>
                    </button>
                  </div> 



                  <div v-if="this.currentPlace.file_type == 'image/jpeg'">
                    <!-- <p>{{this.url_imagen}}</p> -->
                    <v-lazy-image :src="this.url_imagen" />
                  </div>
                  <div v-if="this.currentPlace.file_type == 'video/mp4'">
                    <!-- <p>{{this.url_video}}</p> -->
                    <video
                      :src="this.url_video"
                      width="640"
                      height="480"
                      controls
                      controlsList="nodownload"
                    />
                    
                  </div>
  
              </div>

              <div v-if="this.currentPlace.media_folder != null && this.currentPlace.file_type == 'audio/mpeg'">
                  <!-- <p>{{this.url_audio}}</p> -->
                  <audio :src="this.url_audio" type=”audio/mp3″ controls controlsList="nodownload" />
              </div>               

<!--               <p class="font-bold text-base text-gray-700">Horario:</p>
              <div v-for="(day, index) in workingHours" :key="index">
                <div class="flex w-1/3 text-sm" v-if="day.label !== 'enable' && day.open !== ''">
                  <span class="w-2/5 tracking-wide">{{day.label}}:</span>
                  <span class="w-3/5">{{day.open}} &ndash; {{day.close}}</span>
                </div>
              </div> -->
            </div>
          </div>
        </div> 
        <div class="w-full py-16 text-center text-gray-500" v-else>
          <font-awesome-icon :icon="['fas', 'list']" class="text-6xl mb-4" /> 
          <p class="text-xl font-semibold">Seleccione un registro para ver sus detalles.</p>
        </div>
      </div>
    </div>

<!--     <place-modal
      :showing="showPlaceModal"
      :place="modalPlace"
      :aux_place="aux_modalPlace"
      :modalAction="modalAction"
      @close="closeModal"
      @updateData="updateData"
    ></place-modal> -->

    <place-modal
      :showing="showPlaceModal" 
      :place="modalPlace"
      :aux_place="aux_modalPlace"
      :modalAction="modalAction"
      @close="showPlaceModal = false"
      @updateData="updateData"      
      :geometries="geometries"
      @saved="savedSuccesfully()"
    ></place-modal>    

<!--     <editlev-modal
      :showing="showPlaceModal" 
      :geometries="geometries"
      @close="showPlaceModal = false"
      @saved="savedSuccesfully()"
    ></editlev-modal> -->


    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Los cambios se han guardado</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea eliminar el registro?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="deletePlace()"
        >Eliminar</button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirm = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingUpdateGeomConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Está seguro que desea modificar las geometrías del registro? <br><strong> Esta acción no se puede deshacer</strong></div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="saveGeometries()"
        >Guardar</button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingUpdateGeomConfirm = false"
        >Descartar</button>
      </div>
    </alert-dialog>    

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Registro eliminado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-green"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >Cerrar</button>
      </div>
    </alert-dialog>


        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  

    <place-comments-modal
      :showing="showCommentsModal"
      @close="closeCommentsModal"
      :placeComments="placeComments"
      @updateComments="updateComments"
    ></place-comments-modal>

    <metadata-modal
      :metadata="currentPlace.media_metadata"
      :filetype="currentPlace.file_type"
      :showing="showingMetadata"
      @close="showingMetadata = false"
    ></metadata-modal>

  </div>
</template>

<script>
import { backend_url } from "../config/url.config.ts";
import PlaceModal from "./PlaceModal";
import AlertDialog from "./AlertDialog";
import PlaceCommentsModal from "./PlaceCommentsModal";
import polygon from "../assets/polygonChapp.json";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import * as turf from '@turf/turf';
import ConfirmDialogue from './ConfirmDialogue'
import MetadataModal from "./MetadataModal";

import L from "leaflet";
import { LMap, LMarker, LGeoJson, LTileLayer } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import { stringify } from "wellknown/wellknown.js";
import XLSX from 'xlsx';
import moment from "moment";
import tokml from "tokml"
import shpwrite from "shp-write"
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

import { Icon } from "leaflet";
import BaseButton from "./atoms/BaseButton.vue";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

export default {
  name: "places-list",
  data() {
    return {
      is_selected: false,
      is_editable: true,
      places: [],
      search: "",
      currentPlace: {},
      geom_type: "",
      geom_coords: "",
      geom_length: "",
      geom_area: "",
      geom_altitude: "",
      showPlaceModal: false,
      showingSuccess: false,
      showingConfirm: false,
      showingUpdateGeomConfirm:false,
      showingError: false,
      showingSuccessDelete: false,
      modalPlace: {},
      aux_modalPlace: {},
      modalAction: "",
      url_imagen: "",
      url_video: "",
      url_audio: "",
      isLoading: false,
      fullPage: true, 
      featuresList: [],
      geometries: [],
      drawnItems: null,
      drawnItemsNonEditable: null,
      drawnItemsNonEditableBackup: null,
      geojsonGeometries: null,
      drawControl: null,

      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      placeComments: [],
      showCommentsModal: false,
      categoryFilter: "-1",
      placeCategories: [],
      formOrder: "upward",
      polygon: polygon,
      srcUrl: backend_url,
      zoom: 8,
      minZoom: 3,
      maxZoom:22,
      center:  [20.586510, -89.015010],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false
      },
      json_fields: {
        Nombre: "nombre",
        "Descripción": "descripcion",
        Fecha: "fecha_levantamiento",
        Proyecto: "proyecto_nombre",
        "Categoría": "cat_principal_nombre",
        Tipo: "tipo_nombre",
        "Subcategoría": "cat_secundaria_nombre",
        "Subido por": "usuario"
//        "Geometría": "geojson"

/*         Apellido: "last_name",
        Categoria: "name_category",
        Correo: "email",
        Edad: "age",
        Sexo: "sex",
        Telefono: "phone_number",
        Dirección: "address",
        "Url de perfil": "profile_image",
        ID: "auth_id",
        Dispositivo: "device_id" */
      },      
      showingMetadata: false,
      urlBaseMap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      selectedPlaces: [],
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    PlaceModal,
    LTileLayer,
    AlertDialog,
    PlaceCommentsModal,
    Loading,
    ConfirmDialogue,
    MetadataModal,
    BaseButton
  },
  created() {
    let that = this;
/*     this.$socket.$subscribe("updateCategoryPlaceToMonitor", () => {
      that.fetchPlaces();
      that.fetchPlaceCategories();
    }); */
  },
  mounted() {
    this.fetchPlaces();
    this.fetchPlaceCategories();
  },
  methods: {
    onMapReady: function() {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        
        // var satellite = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
        var satellite = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
          attribution: '"Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
        });
        
        // esri.basemapLayer("ImageryLabels").addTo(map);
        var topo = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap<\/a> contributors'
        });
        //var streets = esri.basemapLayer("Streets")
        //esri.basemapLayer("Topographic").addTo(map);
        //esri.basemapLayer("Imagery").addTo(map);
        // satellite.addTo(map)
        map.layers = [satellite,topo]
        var baseMaps = {
            "Satélite": satellite,
            //"Calles": streets,
            "Calles": topo,
        };

        L.control.layers(baseMaps).addTo(map);
      });
    },
    fetchPlaces() {
      
      this.axios
        .post(backend_url + "/api/ppd/levantamiento/getLevantamientosGeneral", this.config)
        .then(response => {
          //console.log(response)
          //console.log(response.data.levantamientos)
  
          this.places = response.data.levantamientos;
          
          // Si el usuario cuenta con un Project_ID es usuario de aplicación movil
          const project_id = localStorage.getItem("project_id");
          if(parseInt(project_id) !== 0) {
            this.places = this.places.filter(({id_proyecto}) => id_proyecto === project_id)
          }

          //console.log(this.places)

          this.places.forEach(place => {
//           console.log(place)
            //console.log(place.geojson)
            let geojsonGeometries = JSON.parse(place.geojson)
//           console.log(geojsonGeometries)
            let numGeometries = geojsonGeometries.features.length
//             console.log(numGeometries)
            place["geometries"] = []
            geojsonGeometries.features.forEach(feature =>{
//              console.log(feature)
              let featureType = ""
              let punto, longitud, area;
              switch(feature.geometry.type){
                case "Point":
                  featureType = "Punto"
                  punto = "["+feature.geometry.coordinates[0]+", "+feature.geometry.coordinates[1]+"]"
                  longitud = "N/A"
                  area = "N/A"
                  break;
                case "LineString":
                  featureType = "Línea"
                  let lon = turf.length(feature.geometry, {
                    units: "kilometers",
                  });
                  longitud = lon.toFixed(2)+" km."
                  punto = "N/A"
                  area = "N/A"
                  break;
                case "Polygon":
                  featureType = "Polígono"
                  let ar = turf.area(feature.geometry); //en m2
                  let area_ha = ar/10000
                  area = area_ha.toFixed(2)+" ha"
                  punto = "N/A"
                  longitud = "N/A"
                  break;
              }
              let newGeom = {
                tipo : featureType,
                punto: punto,
                longitud: longitud,
                area: area,
                geojson : JSON.stringify( {
                  type: "Feature",
                  geometry: feature.geometry
                }),
                wkt: stringify(feature.geometry)
              }
              place["geometries"].push(newGeom)
            })
          })
          
 
        })
        .catch(error => {
            console.log(error)
/*           if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false; */
        });
    },
    removeLineBreaks(description) {
      if (description === undefined || description === null) {
        return "";
      } else {
        return description.replace(/(?:\\r\\n)/g, "<br />");
      }
    },
    selectPlace(place) {
      this.is_selected = true;
      this.is_editable = localStorage.getItem('email') === place.usuario || parseInt(localStorage.getItem('project_id')) === 0;
      this.geom_type = null;
      this.geom_coords = null;
      this.geom_length = null;
      this.geom_area = null;
      this.geom_altitude = null;
      let that=this
      this.map = this.$refs.map.mapObject;
      this.geojsonGeometries = null;
      this.geometries =[]
      
      this.featuresList = []
      if(this.drawnItems!=null){
          //this.map.off('draw:created');
          this.map.off('draw:edited');
          this.map.off('draw:deleted');

          //this.drawControl
          //this.drawControl._toolbars.edit.disable

          this.drawnItems.clearLayers();
          this.map.removeLayer(this.drawnItems)

          this.drawnItemsNonEditable.clearLayers();
          this.drawnItemsNonEditableBackup.clearLayers();
          this.map.removeLayer(this.drawnItemsNonEditable)
      }

      if(this.drawControl)
          this.map.removeControl(this.drawControl);

      this.drawnItems = null;
      this.drawnItemsNonEditable = null;
      this.drawControl = null;
      this.currentPlace = place;

      for (let i = 0; i < this.currentPlace.geometries.length; i++) {
        if ( i == 0 ) {
          this.geom_type = this.currentPlace["geometries"][i].tipo;
          this.geom_coords = this.currentPlace["geometries"][i].punto;
          this.geom_length = this.currentPlace["geometries"][i].longitud;
          this.geom_area = this.currentPlace["geometries"][i].area;
        } else {
          this.geom_type = this.geom_type + ", " + this.currentPlace["geometries"][i].tipo;
          this.geom_coords = this.geom_coords + ", " + this.currentPlace["geometries"][i].punto;
          this.geom_length = this.geom_length + ", " + this.currentPlace["geometries"][i].longitud;
          this.geom_area = this.geom_area + ", " + this.currentPlace["geometries"][i].area;
        }
      }
      
      this.modalPlace = {};

      if((this.currentPlace.media_folder != null ) && (this.currentPlace.file_type == 'image/jpeg')){
          this.url_imagen = backend_url+this.currentPlace.media_folder.substring(1);
      }
      if((this.currentPlace.media_folder != null) && (this.currentPlace.file_type == 'video/mp4')){
          this.url_video = backend_url+this.currentPlace.media_folder.substring(1);
      }
      if((this.currentPlace.media_folder != null) && (this.currentPlace.file_type == 'audio/mpeg')){
          this.url_audio = backend_url+this.currentPlace.media_folder.substring(1);
      }

      try{
        this.geojsonGeometries = JSON.parse(this.currentPlace.geojson)
      }
      catch{
        this.geojsonGeometries = this.currentPlace.geojson
      }
      
      //console.log(this.geojsonGeometries)  //featureCollection

      this.drawnItems = new L.FeatureGroup();
      this.drawnItemsNonEditable = new L.FeatureGroup();
      this.drawnItemsNonEditableBackup = new L.FeatureGroup();

      //console.log(this.geojsonGeometries.features.length)
      //console.log(this.currentPlace.source)

      //**---- se agrega para compatibilidad de los registros leventados con la app que no tienen en campo "typeGeometry"
      if(this.geojsonGeometries.features.length > 1 && this.currentPlace.source == 'app'){
        //console.log("es una zona de influencia de la app")
        let geomId = 100; //un id para identificar marcador y su buffer
        this.geojsonGeometries.features.forEach((feature,index) => {
            //console.log(feature)
            //console.log(feature.geometry.type)
            switch(feature.geometry.type){
              case "Point": //es el centro de la zona de influencia
                if(feature.properties["typeGeometry"] == undefined){
                  feature.properties["typeGeometry"] = "MarkerToBuffer";
                }
                feature.properties["geomID"] = geomId;
                break;
              case "Polygon": //es el círculo de la zona de influencia
                if(feature.properties["typeGeometry"] == undefined){
                  feature.properties["typeGeometry"] = "Buffer";
                }
                var centroid = turf.centroid(feature.geometry); //calcula el centro de la zona, debe ser aprox el mismo "Point"
                console.log(centroid)
                var distance = Math.round(turf.distance(centroid, feature.geometry.coordinates[0][0])); //calcula la distancia entre en ecentro y un punto del círculo de la zona
                console.log(distance)
                let radio = Math.round(distance); //se redondea el radio
                feature.properties["radioValueParsed"] = radio;
                feature.properties["geomID"] = geomId;
                break;
            }
        })

      }      
      //**------

      this.geojsonGeometries.features.forEach((feature,index) => {
        //console.log(feature.properties["typeGeometry"])
        console.log(feature)
        if(feature.properties["typeGeometry"]!= undefined){
          //console.log(feature.properties["typeGeometry"])

          if(feature.properties["typeGeometry"]!= "Buffer" || feature.properties["typeGeometry"]!= "Buffer"){ //si no es buffer (zona de influencia) lo agrega a editables
            feature["properties"]["editId"] = index; //agrega un indice para sabe cual se editó
            that.addNonGroupLayers(L.geoJSON(feature),this.drawnItems)
            this.featuresList.push(feature)              
          }
          else{
            //console.log("es buffer") //si es buffer sólo lo pinta en el mapa, sin posibilidad de editar (se editará al mover su marcador correspondiente)
            that.addNonEditableGroupLayers(L.geoJSON(feature),this.drawnItemsNonEditable)
            that.addNonEditableGroupLayers(L.geoJSON(feature),this.drawnItemsNonEditableBackup)
            this.featuresList.push(feature)  //se agrega a features pero sin índice de edición 

          }

        }
        else{
          feature["properties"]["editId"] = index; //agrega un indice para sabe cual se editó
          that.addNonGroupLayers(L.geoJSON(feature),this.drawnItems)
          this.featuresList.push(feature)          

        }

        //console.log(feature.geometry.type)
        //L.geoJSON(feature).addTo(this.drawnItems);
        //console.log(feature, index)

/*         feature["properties"]["editId"] = index; //agrega un indice para sabe cual se editó
        that.addNonGroupLayers(L.geoJSON(feature),this.drawnItems)
        this.featuresList.push(feature) */

/*         console.log(feature.geometry.coordinates)
        switch(feature.geometry.type){
          case "LineString":
              let linestring = L.polyline(feature.geometry.coordinates,{color: 'red'}).addTo(this.map)
             // this.drawnItems.addLayer(linestring)
              //linestring.addTo(this.drawnItems)
              break;
            case "Polygon":
              let polygon = L.polygon(feature.geometry.coordinates,{color: 'red'}).addTo(this.map)
              //this.drawnItems.addLayer(polygon)
              //polygon.addTo(this.drawnItems)
              break;              
        } */

      })

      console.log(this.featuresList)
      //console.log(this.drawnItems)
      this.drawnItems.eachLayer(layer => {
        // console.log(layer.feature)
      });


      this.map.addLayer(this.drawnItems);
      //this.polygon = geojson

      //this.drawnItemsNonEditableBackup = this.drawnItemsNonEditable
      //this.drawnItemsNonEditableBackup = Object.assign({}, this.drawnItemsNonEditable);

      this.map.addLayer(this.drawnItemsNonEditable);

 /*      this.drawnItemsNonEditable.eachLayer(layer => {
         console.log(layer)
         console.log(layer.toGeoJSON().features[0].properties)
      }); */


      //this.center = [place.lat, place.lng];
      

      let bbox = turf.bbox(this.geojsonGeometries)
      //console.log(turf.bbox(geojson))
      //console.log(this.map)
      this.map.fitBounds([[bbox[1],bbox[0]],[bbox[3],bbox[2]]], {padding: [50, 50]})

       console.log(this.geojsonGeometries)
      if(this.geojsonGeometries.features.length == 1){
        //console.log("solo es uno")
        if(this.geojsonGeometries.features[0].geometry.type == "Point"){
          //console.log("solo es un punto")
          this.map.setZoom(13)
        }
      }


      this.editGeometry()
      //this.fetchPlaceComments(place.id);
      //showPolygonInMap();
    },

    togglePlace(id) {
      if (this.selectedPlaces.includes(id)) {
        this.selectedPlaces = this.selectedPlaces.filter(p => p !== id)
      } else {
        this.selectedPlaces.push(id)
      }
    }, 
    
    addNonGroupLayers(sourceLayer, targetGroup) {
      //funcion auxiliar para convertir geosjon a capas de leaflet editables
      let that=this;
      if (sourceLayer instanceof L.LayerGroup) {
        sourceLayer.eachLayer(function (layer) {
          that.addNonGroupLayers(layer, targetGroup);
        });
      } else {
        //console.log(sourceLayer)
        //console.log(sourceLayer.feature.properties)
        //si es el marcador de un buffer le asigna un evento dragend para recalcular el buffer
        if(sourceLayer.feature.properties["typeGeometry"]!= undefined){
          if(sourceLayer.feature.properties["typeGeometry"] == "MarkerToBuffer"){
              let radioBuffer;
              
              sourceLayer.on('dragend', function(event) {
                //console.log("calculate radio...")
                //---- "calculate radio..."
                //let radioBuffer = that.getRadioBuffer(sourceLayer)
                //console.log(radioBuffer)                
                let bufferGeomID = sourceLayer.feature.properties["geomID"]
                if(sourceLayer.feature.properties["radioValueParsed"] != undefined){
                    radioBuffer = sourceLayer.feature.properties["radioValueParsed"]
                }
                else{
                  that.drawnItemsNonEditable.eachLayer(layer => {
                      //console.log(layer.toGeoJSON().features[0].properties.geomID)
                      if(layer.toGeoJSON().features[0].properties["geomID"] == bufferGeomID){ //si el buffer corresponde al marcador
                          //console.log("corresponde")
                          if(layer.toGeoJSON().features[0].properties["radioValueParsed"] != undefined){
                            //console.log("return radioValueParsed")
                            //console.log(layer.toGeoJSON().features[0].properties["radioValueParsed"])
                            radioBuffer = layer.toGeoJSON().features[0].properties["radioValueParsed"]
                          }
                          else{ //si no tiene la propiedad de radio lo calcula
                            let geometria = layer.toGeoJSON().features[0].geometry
                            var centroid = turf.centroid(geometria); //calcula el centro de la zona, debe ser aprox el mismo "Point"
                            //console.log(centroid)
                            var distance = Math.round(turf.distance(centroid, geometria.coordinates[0][0])); //calcula la distancia entre en ecentro y un punto del círculo de la zona
                            //console.log(distance)
                            let radio = Math.round(distance); //se redondea el radio
                            layer.toGeoJSON().features[0].properties["radioValueParsed"] = radio;
                            //console.log("return radio")
                            radioBuffer = radio;
                          }
                      }

                  });        
                }
                //------ "calculate radio..."

                //var mylat = event.latlng.lat
                var result = sourceLayer.getLatLng(); 
                //console.log(result);
                let point = turf.point([result.lng, result.lat])
                let circleInfluenceZone = turf.buffer( point, radioBuffer, { units: 'kilometers' })
                //let circleInfluenceZone = turf.buffer( point, that.getRadioBuffer(sourceLayer), { units: 'kilometers' })
                //that.addNonEditableGroupLayers(circleInfluenceZone,that.drawnItemsNonEditable)
                //circleInfluenceZone.properties = sourceLayer.feature.properties;
                circleInfluenceZone.properties = Object.assign({}, sourceLayer.feature.properties);
                circleInfluenceZone.properties["typeGeometry"] = "Buffer";
                circleInfluenceZone.properties["radio"] = radioBuffer;
                //console.log(circleInfluenceZone)
                
                let layertoUpdate;
                that.drawnItemsNonEditable.eachLayer(layer => {
                  //console.log(layer.toGeoJSON())
                  let nonEditablelayer = layer.toGeoJSON().features[0]
                  //console.log(nonEditablelayer)
                  if(nonEditablelayer.properties.geomID == circleInfluenceZone.properties.geomID){
                    //console.log("update Geometry")
                    layertoUpdate = layer;
                    nonEditablelayer.geometry = circleInfluenceZone.geometry;
                    circleInfluenceZone.properties["radioValueParsed"] = nonEditablelayer.properties["radioValueParsed"];
                    //circleInfluenceZone.properties["layerBufferID"] = nonEditablelayer.properties["layerBufferID"];
                  }
                });
                //that.map.removeLayer(that.drawnItemsNonEditable);
                //that.map.addLayer(that.drawnItemsNonEditable);

                that.drawnItemsNonEditable.removeLayer(layertoUpdate)
                that.drawnItemsNonEditable.addLayer(L.geoJson(circleInfluenceZone))
                //that.drawnItemsNonEditable.
              }); 
          }
        }

        targetGroup.addLayer(sourceLayer);
        
      }
    },    
    addNonEditableGroupLayers(sourceLayer, targetGroup) {
      //funcion auxiliar para convertir geosjon a capas de leaflet No editables
      //console.log(sourceLayer,targetGroup)
      targetGroup.addLayer(sourceLayer);
/*       let that=this;
      if (sourceLayer instanceof L.LayerGroup) {
        sourceLayer.eachLayer(function (layer) {
          that.addNonGroupLayers(layer, targetGroup);
        });
      } else {
        targetGroup.addLayer(sourceLayer);
      } */
    },    
    getRadioBuffer(buffer){
      //console.log("getRadioBuffer")
      //console.log(buffer.feature.properties)
      let bufferGeomID = buffer.feature.properties["geomID"]
      if(buffer.feature.properties["radioValueParsed"] != undefined){
        return buffer.feature.properties["radioValueParsed"]
      }
      else{
        this.drawnItemsNonEditable.eachLayer(layer => {
             //console.log(layer.toGeoJSON().features[0].properties.geomID)
             if(layer.toGeoJSON().features[0].properties["geomID"] == bufferGeomID){ //si el buffer corresponde al marcador
                //console.log("corresponde")
                if(layer.toGeoJSON().features[0].properties["radioValueParsed"] != undefined){
                  //console.log("return radioValueParsed")
                  //console.log(layer.toGeoJSON().features[0].properties["radioValueParsed"])
                  return layer.toGeoJSON().features[0].properties["radioValueParsed"]
                }
                else{ //si no tiene la propiedad de radio lo calcula
                  let geometria = layer.toGeoJSON().features[0].geometry
                  var centroid = turf.centroid(geometria); //calcula el centro de la zona, debe ser aprox el mismo "Point"
                  //console.log(centroid)
                  var distance = Math.round(turf.distance(centroid, geometria.coordinates[0][0])); //calcula la distancia entre en ecentro y un punto del círculo de la zona
                  //console.log(distance)
                  let radio = Math.round(distance); //se redondea el radio
                  layer.toGeoJSON().features[0].properties["radioValueParsed"] = radio;
                  //console.log("return radio")
                  return radio;
                }
             }

        });        
      }
    },  
    showPolygonInMap(){
      if (this.currentEvent.ruta !== null) {
        if(this.currentEvent.kml!=null){
          const type = this.currentEvent.kml.split(".")[1];
          if(type=="kml"){
            this.resetFileGeometryInMap();
            this.geojsonRouter = null;
            var oReq = new XMLHttpRequest();
            oReq.addEventListener("load", () => {
              this.loadKml(oReq.responseText)
            });
            oReq.open("GET", backend_url+"/"+this.currentEvent.kml);
            oReq.send();
          }

          if(type=="kmz"){
            this.resetFileGeometryInMap();
            this.kmzParser.load(backend_url+"/"+this.currentEvent.kml)
          }
        }else{
          this.resetFileGeometryInMap();
          this.geojsonRouter = this.currentEvent.ruta;
        }
      } else {
        this.resetFileGeometryInMap();
        this.geojsonRouter = null;
      }

    },
    editGeometry(){
      console.log("editGeometry")
      let that=this
        //if(this.drawControl == null){
          //console.log("creae draw tool")
          this.drawControl = new window.L.Control.Draw({
            //position: "topright",
            //position: "topleft",
            position: "bottomleft",
            draw: {
/*               polyline: {
                showLength:true
              },
              polygon: {
                showArea:true,
                showLength:true
              }, */
              polyline:false,
              polygon: false,
              rectangle: false,
              circle: false,
              marker: false,
              circlemarker: false
            },
            edit: {
              featureGroup: that.drawnItems,
              remove: false 
            }
          });
        //}
        //console.log(this.drawnItems)
        //this.controlAdd = drawControl;

        this.drawControl._toolbars.edit.disable =  function () {
          if (!this.enabled()) {
            /* If you need to do something right as the
              edit tool is enabled, do it here right
              before the return */
            return;
          }

          this._activeMode.handler.revertLayers();
          /* If you need to do something when the
            cancel button is pressed and the edits
            are reverted, do it here. */
            //console.log("cancel edit")
            that.map.removeLayer(that.drawnItemsNonEditable);
            //that.drawnItemsNonEditable = that.drawnItemsNonEditableBackup
            //that.drawnItemsNonEditable = Object.assign({}, that.drawnItemsNonEditableBackup);
            that.drawnItemsNonEditable.clearLayers();
            that.drawnItemsNonEditableBackup.eachLayer(layer => {
              //console.log(layer)
              that.addNonEditableGroupLayers(L.geoJSON(layer.toGeoJSON()),that.drawnItemsNonEditable)
            });            
            
            that.map.addLayer(that.drawnItemsNonEditable);
          L.Toolbar.prototype.disable.call(this);
        };


        this.drawControl.addTo(this.map);

        this.map.on("draw:edited", e => {
          //console.log("draw edit")
          let layers = e.layers;
          //console.log(layers)
          this.geometries = []
          layers.eachLayer(layer => { //itera sobre las geometrías que fueron editadas
            //console.log(layer.feature)
            that.featuresList.forEach(feat =>{ //itera sobre la lista de features
              //console.log(feat)
              if(layer.feature.properties.editId != undefined){ //si tiene un id de edición
                  if(layer.feature.properties.editId == feat.properties.editId){
                    //console.log("se editó",feat.properties.editId)
                    let editedGeometryGeojson = layer.toGeoJSON().geometry;

                    if(layer.feature.properties["typeGeometry"]!= undefined){
                      if(layer.feature.properties["typeGeometry"] == "MarkerToBuffer"){ //es el marcador de un buffer (zona de influencia)
                          let bufferId = layer.feature.properties["geomID"]
                          //busca en los features el buffer correspondiente al marcador
                          that.featuresList.forEach(featur =>{
                            if(featur.properties["geomID"] == bufferId && featur.properties["typeGeometry"]=="Buffer"){
                              //es el feature que corresponde a la zona del marcador
                              //console.log(featur)
                              //busca en los no editables la geometría correspondiente
                              this.drawnItemsNonEditable.eachLayer(layer => {
                                //console.log(layer)
                                let propertiesLayer = layer.toGeoJSON().features[0].properties;
                                let geometryLayer = layer.toGeoJSON().features[0].geometry;
                                //console.log(layer.toGeoJSON().features[0].properties)
                                if(propertiesLayer["geomID"] == bufferId && propertiesLayer["typeGeometry"]=="Buffer"){
                                  //console.log("actualiza la geometría!")
                                  //console.log(geometryLayer)
                                  featur.geometry = geometryLayer;
                                }
                              });
                            }
                          })
                      }
                    }
                    //console.log(feat.geometry)
                    //console.log(layer.feature.geometry)
                    //console.log(editedGeometryGeojson)
                    //feat.geometry = layer.feature.geometry
                    feat.geometry = editedGeometryGeojson
                  }
              }
            })

/*             this.noticeArea = layer.toGeoJSON().geometry;
            console.log(this.noticeArea)
            this.geometries.push(this.noticeArea) */
          });
          // console.log("geometries:",this.geometries)
          this.showingUpdateGeomConfirm = true;
        });

        this.map.on("draw:created", e => {
          // console.log("draw created")
          var layer = e.layer;
          //console.log(layer)
          //this.noticeArea = layer.toGeoJSON().geometry;
          this.noticeArea = layer.toGeoJSON();
          this.noticeArea.properties = {}

          switch(this.noticeArea.geometry.type){
            case "Polygon":
              //this.noticeArea.properties.area = 23
              this.noticeArea.properties.area = turf.area(this.noticeArea.geometry)/1000000 //en km2
              //console.log(stringify(this.noticeArea))
              break;
            case "LineString":
              //this.noticeArea.properties.longitud = 54
              this.noticeArea.properties.longitud = turf.length(this.noticeArea.geometry, {units: 'kilometers'})
              //console.log(stringify(this.noticeArea))
              break;
            case "Point":
              //this.noticeArea.properties.longitud = 54
              this.noticeArea.properties.position = {lat: this.noticeArea.geometry.coordinates[0], lng: this.noticeArea.geometry.coordinates[1] }
              //console.log(stringify(this.noticeArea))
              break;              
          }
          //console.log(this.noticeArea)
          this.geometries.push(this.noticeArea)

          //console.log(this.geometries)
          layer.addTo(this.drawnItems);


        });

        this.map.on("draw:deleted", e => {
          // console.log("draw delete")
          this.doDelete(e)



/*            let layers = e.layers;
          console.log(layers)
          this.geometries = []
          layers.eachLayer(layer => { //itera sobre las geometrías que fueron editadas
            //console.log(layer.feature)
            that.featuresList.forEach(feat =>{ //itera sobre la lista de features
              //console.log(feat)
              if(layer.feature.properties.editId == feat.properties.editId){
                console.log("se eliminó",feat.properties.editId)
//                let editedGeometryGeojson = layer.toGeoJSON().geometry;
                //console.log(feat.geometry)
                //console.log(layer.feature.geometry)
                //console.log(editedGeometryGeojson)
                //feat.geometry = layer.feature.geometry
  //              feat.geometry = editedGeometryGeojson
              }
            })
          }); */
          //console.log("geometries:",this.geometries)
          //this.showingUpdateGeomConfirm = true;
        });    
        
        


    },
    async doDelete(e) {
            let that=this;
            const ok = await this.$refs.confirmDialogue.show({
                title: '',
                message: '¿ESTÁ SEGURO DE QUE DESEA BORRAR LAS GEOMETRÍAS? ESTA ACCIÓN NO SE PUEDE DESHACER',
                okButton: 'Borrar',
            })
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                //alert('You have successfully delete this page.')
                // console.log("borrar!")
                // console.log(e)
                let layers = e.layers;
                // console.log(layers)
                this.geometries = []
                let deletedIndexes = []
                layers.eachLayer(layer => { //itera sobre las geometrías que fueron editadas
                  //console.log(layer.feature)
                  that.featuresList.forEach((feat,index) =>{ //itera sobre la lista de features
                    //console.log(feat)
                    if(layer.feature.properties.editId == feat.properties.editId){
                      // console.log("se eliminó",feat.properties.editId)
      //                let editedGeometryGeojson = layer.toGeoJSON().geometry;
                      //console.log(feat.geometry)
                      //console.log(layer.feature.geometry)
                      //console.log(editedGeometryGeojson)
                      //feat.geometry = layer.feature.geometry
        //              feat.geometry = editedGeometryGeojson
                      // console.log(index)
                      deletedIndexes.push(index)
                    }
                  })
                });     
                
                let newfeaturesList = []
                this.featuresList.forEach((feat,index) =>{
                    if(!deletedIndexes.includes(index)){
                      newfeaturesList.push(feat)
                    }
                })

                // console.log(newfeaturesList)

            } else {
                // console.log("nada")
                //alert('You chose not to delete this page. Doing nothing now.')
            }
    },    

    saveGeometries(){
        // console.log("guardar geometrías")
        //console.log(this.featuresList)
        //console.log(this.currentPlace)
        this.showingUpdateGeomConfirm = false
        this.isLoading=true;
        this.geometries = []
        let projectInfo ={
          id: this.currentPlace.id_proyecto,
          nombre: this.currentPlace.proyecto_nombre
        }
        let categoryInfo = {
          id: this.currentPlace.id_cat_principal,
          nombre: this.currentPlace.cat_principal_nombre
        }
        let subCategoryInfo = {
          id: this.currentPlace.id_cat_secundaria,
          id_maincategory: this.currentPlace.id_cat_principal,
          nombre: this.currentPlace.cat_secundaria_nombre,
          tipo_id: this.currentPlace.id_tipo
        }
        let typeInfo={
          id: this.currentPlace.id_tipo,
          nombre: this.currentPlace.tipo_nombre
        }
        this.featuresList.forEach(feature =>{
          // console.log(feature)
          let newFeature = {
            type: "Feature",
            properties:{
                projectInfo: projectInfo,
                categoryInfo: categoryInfo,
                typeInfo: typeInfo,
                subCategoryInfo: subCategoryInfo
            },
            geometry: feature.geometry
          }

          Object.entries(feature.properties).forEach(([key, value]) => { //conserva las otras propiedades
              if(key != "projectInfo" && key!= "categoryInfo" && key!="typeInfo" && key!= "subCategoryInfo" && key!= "editId"){
                newFeature.properties[key] = value;
              }
          });

          this.geometries.push(newFeature)

        })
        //console.log(this.geometries)

        let featureCollectionGeometries = {
          type: "FeatureCollection",
          features: this.geometries
        }
        //console.log(featureCollectionGeometries);  

        let data = {
          id: this.currentPlace.id,
          geometries: featureCollectionGeometries
        }

        this.axios
          .put(
            backend_url + "/api/ppd/levantamiento/updateLevantamientoGeometries/"+this.currentPlace.id,
            data,
            this.config
          )
          .then((response) => {
            // console.log(response);
            // console.log(response.data.status);
            if(response.data.status == 'ok'){
              // console.log("Se han guardado los datos")
              //this.savedSuccesfully();
              this.currentPlace.geojson = featureCollectionGeometries
              //console.log(this.currentPlace.geojson)
              this.isLoading=false;
              //alert("Se han guardado los datos");
              this.showingSuccess = true
              
            }
          })
          .catch((error) => {
            console.log(error);
            //this.showingError = true;
            this.isLoading=false;
            //alert("Ha ocurrido un error");
            this.showingError = true;
          }        
          );


    },

    closeModal(type) {
      if (type === "dismiss") {
        this.showPlaceModal = false;
      } else {
        this.fetchPlaces();
        this.search = "";
        this.showPlaceModal = false;
        this.showingSuccess = true;
      }
    },

    savedSuccesfully(){
        this.fetchPlaces();
        this.search = "";
        this.showPlaceModal = false;
        this.showingSuccess = true;      
        this.updateData()
    },

    updateData(){
     // console.log("update data")
      if(this.modalPlace)
        this.currentPlace = this.modalPlace;
      //if(this.modalPlace.descripcion)
      //  this.currentPlace.descripcion = this.modalPlace.descripcion;
    },
    deletePlace() {
      this.isLoading=true;
      this.axios
        .delete(
          backend_url + "/api/ppd/levantamiento/deleteLevantamiento/" + this.currentPlace.id,
          this.config
        )
        .then(response => {
          return this.axios.post(
            backend_url + "/api/binnacles/monitor/save/",
            {
              module: "Levantamientos",
              action: "Elminación de un Levantamiento",
              observation: this.currentPlace.nombre,
              email: localStorage.getItem("email")
            },
            this.config
          );
        })
        .then(response => {
          this.currentPlace = {};
          this.fetchPlaces();
          this.search = "";
          this.showingConfirm = false;
          this.isLoading=false;
          this.showingSuccessDelete = true;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    openAddModal() {
      // this.modalPlace = {'working_hours': {
      this.modalPlace = {
        working: {
          monday: ["00:00", "00:00"],
          tuesday: ["00:00", "00:00"],
          wednesday: ["00:00", "00:00"],
          thursday: ["00:00", "00:00"],
          friday: ["00:00", "00:00"],
          saturday: ["00:00", "00:00"],
          sunday: ["00:00", "00:00"],
          enable: {
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false
          }
        }
      };
      this.modalAction = "add";
      this.showPlaceModal = true;
    },
    openEditModal() {
      // console.log(this.currentPlace)
      this.modalPlace = Object.assign({}, this.currentPlace);
      this.aux_modalPlace = Object.assign({}, this.currentPlace);

      this.modalPlace.id_proyecto = parseInt(this.modalPlace.id_proyecto)

      this.modalAction = "edit";
      // console.log(this.modalPlace)
      this.showPlaceModal = true;
    },
    fetchPlaceComments(placeId) {
      this.axios
        .get(backend_url + "/api/comments_places/" + placeId, this.config)
        .then(response => {
          this.placeComments = response.data;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = false;
        });
    },
    closeCommentsModal() {
      this.showCommentsModal = false;
    },
    updateComments() {
      this.fetchPlaceComments(this.currentPlace.id);
    },
    fetchPlaceCategories() {
      this.axios
        .get(backend_url + "/api/ppd/proyectos/getProjects", this.config)
        .then((response) => {
         // console.log(response.data.proyectos);
          this.placeCategories = response.data.proyectos;

          // Si el usuario cuenta con un Project_ID es usuario de aplicación movil
          const project_id = localStorage.getItem("project_id");
          if(parseInt(project_id) !== 0) {
            this.placeCategories = this.placeCategories.filter(({id}) => id === parseInt(project_id))
          }
          console.log(this.placeCategories);
        });

/*       this.axios
        .get(backend_url + "/api/places/category", this.config)
        .then(response => {
          this.placeCategories = response.data;
        }); */
    },
    changeFormOrder() {
      if (this.formOrder === "upward") {
        this.formOrder = "downward";
      } else {
        this.formOrder = "upward";
      }
    },

    startDownload(){
      this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
        "module": "Registros", 
        "action": "Descarga de información de todos los registros", 
        "observation": 'Información en formato excel',
        "email": localStorage.getItem("email")
        },
        this.config
      )
      .then(response => {
        //console.log(response)
      })
      .catch(error => {
        console.log(error)
      });
    },

    onexport(){
      // console.log("onexport")
      //console.log(this.currentPlace)

      let visibilidad = "";
      let fechaLevantamientoObj = "";
      let fechaLevantamientoMomentObj = "";
      let fechaLevantamientoMomentString = "";
      let metodoRegistro = "";

      if(this.currentPlace.privado == null) {
        visibilidad = "N/A";
      } else {
        if(this.currentPlace.privado === true) {
          visibilidad = "Privado";
        } else {
          visibilidad = "Público";
        }
      }

      if( this.currentPlace.fecha_levantamiento != null ) {
        fechaLevantamientoObj = new Date(this.currentPlace.fecha_levantamiento);
        fechaLevantamientoMomentObj = moment(fechaLevantamientoObj);
        fechaLevantamientoMomentString = fechaLevantamientoMomentObj.format('DD/MM/YYYY hh:mm a');
      } else {
        fechaLevantamientoMomentString = "null";
      }

      if(this.currentPlace.geosource == null) {
        metodoRegistro = "N/A";
      } else {
        if(this.currentPlace.geosource === "manual") {
          metodoRegistro = "Manual";
        } else {
          metodoRegistro = "GPS";
        }
      }

      //página deinformación
      const info = {
        Nombre: this.currentPlace.nombre,
        Descripción: this.currentPlace.descripcion,
        Fecha: fechaLevantamientoMomentString,
        Proyecto: this.currentPlace.proyecto_nombre,
        Categoría: this.currentPlace.cat_principal_nombre,
        Tipo: this.currentPlace.tipo_nombre,
        Subcategoría: this.currentPlace.cat_secundaria_nombre,
        "Subido por": this.currentPlace.usuario,
        "Visibilidad": visibilidad,
        "Método de registro": metodoRegistro
      };    
      

      const registroInfo = XLSX.utils.json_to_sheet([info]);
      const geometriesInfo = XLSX.utils.json_to_sheet(this.currentPlace.geometries);

      var wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, registroInfo, "Información");
      XLSX.utils.book_append_sheet(wb, geometriesInfo, "Geometría");

      let fielname = "Registro_"+this.currentPlace.id+".xlsx"
      XLSX.writeFile(wb, fielname);
      //XLSX.writeFile(wb, "Regsitro.xlsx");

      this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
        "module": "Registros", 
        "action": "Descarga de información de un registro", 
        "observation": "Registro descargado en excel: "+this.currentPlace.nombre,
        "email": localStorage.getItem("email")
        },
        this.config
      )
      .then(response => {
        //console.log(response)
      })
      .catch(error => {
        console.log(error)
      }); 


    },
    onexportAll(){
      // console.log("onexportAll")
    //  console.log(this.places)
      let oportunidades = []
      let amenazas = []

      this.places.forEach(registro => {

      let superficie = "N/A", coordenadas = "N/A", longitud = "N/A", tipo = "N/A"
      let visibilidad = "";
      let fechaLevantamientoObj = "";
      let fechaLevantamientoMomentObj = "";
      let fechaLevantamientoMomentString = "";
      let metodoRegistro = "";

      if(registro.geometries.length == 1){
        superficie = registro.geometries[0].area
        longitud = registro.geometries[0].longitud
        coordenadas = registro.geometries[0].punto      
        tipo =   registro.geometries[0].tipo  
      }
      else{
        registro.geometries.forEach(geom => {
          if(superficie == "N/A"){
              superficie = geom.area
          }
          else{
            if(geom.area!="N/A"){
                superficie = superficie+", "+geom.area
            }
          }

          if(longitud == "N/A"){
            longitud = geom.longitud
          }
          else{
            if(geom.longitud != "N/A"){
              longitud = longitud+", "+geom.longitud
            }
          }

          if(coordenadas == "N/A"){
            coordenadas = geom.punto
          }
          else{
            if(geom.punto != "N/A"){
              coordenadas = coordenadas+", "+geom.punto
            }
          }

          if(tipo=="N/A"){
            tipo = geom.tipo
          }
          else{
            tipo = tipo+", "+geom.tipo
          }

        })
      }

      if(registro.privado == null) {
        visibilidad = "N/A";
      } else {
        if(registro.privado === true) {
          visibilidad = "Privado";
        } else {
          visibilidad = "Público";
        }
      }

      if( registro.fecha_levantamiento != null ) {
        fechaLevantamientoObj = new Date(registro.fecha_levantamiento);
        fechaLevantamientoMomentObj = moment(fechaLevantamientoObj);
        fechaLevantamientoMomentString = fechaLevantamientoMomentObj.format('DD/MM/YYYY hh:mm a');
      } else {
        fechaLevantamientoMomentString = "null";
      }

      if(registro.geosource == null) {
        metodoRegistro = "N/A";
      } else {
        if(registro.geosource === "manual") {
          metodoRegistro = "Manual";
        } else {
          metodoRegistro = "GPS";
        }
      }
      
      const info = {
        Nombre: registro.nombre,
        Descripción: registro.descripcion,
        Fecha: fechaLevantamientoMomentString,
        Proyecto: registro.proyecto_nombre,
        Categoría: registro.cat_principal_nombre,
        Tipo: registro.tipo_nombre,
        Subcategoría: registro.cat_secundaria_nombre,
        "Subido por": registro.usuario,
        "Tipo de geometría": tipo,
        "Coordenadas": coordenadas,
        "Longitud": longitud,
        "Superficie": superficie,
        "Visibilidad": visibilidad,
        "Método de Registro": metodoRegistro
        //geojson: registro.geojson
      };   

        if(registro.id_tipo == 1){
          oportunidades.push(info)
        }
        if(registro.id_tipo == 2){
          amenazas.push(info)
        }
      })

     // console.log(oportunidades)
     // console.log(amenazas)

      const oportunidadesInfo = XLSX.utils.json_to_sheet(oportunidades);
      const amenazasInfo = XLSX.utils.json_to_sheet(amenazas);

      var wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, oportunidadesInfo, "Oportunidades");
      XLSX.utils.book_append_sheet(wb, amenazasInfo, "Amenazas");

      let fielname = "RegistrosPPD.xlsx"
      XLSX.writeFile(wb, fielname);      

      this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
        "module": "Registros", 
        "action": "Descarga de información de registros", 
        "observation": "Registros en excel",
        "email": localStorage.getItem("email")
        },
        this.config
      )
      .then(response => {
        //console.log(response)
      })
      .catch(error => {
        console.log(error)
      });      

    },
    
    toGeojsonFile(){
      console.log("toGeojsonFile")
      let that = this;

/*       // Extract GeoJSON from featureGroup
      var data = featureGroup.toGeoJSON();

      // Stringify the GeoJSON
      var convertedData = 'text/json;charset=utf-8,' + 
      encodeURIComponent(JSON.stringify(data));

      // Create export
      document.getElementById('export').setAttribute('href', 'data:' + convertedData);      
      document.getElementById('export').setAttribute('download','data.geojson');
 */
      //console.log(this.currentPlace)
      //console.log(this.currentPlace.geojson)

      let geojsonObject = JSON.parse(this.currentPlace.geojson)

      let geojsonExport = {
        type: 'FeatureCollection',
        features: []
      }

/*       console.log(this.currentPlace.proyecto_nombre)
      console.log(this.currentPlace.cat_principal_nombre)
      console.log(this.currentPlace.cat_secundaria_nombre)
      console.log(this.currentPlace.descripcion)
      console.log(this.currentPlace.tipo_nombre)
      console.log(this.currentPlace.fecha_guardado)
      console.log(this.currentPlace.fecha_levantamiento) */

      let fecha = new Date(this.currentPlace.fecha_levantamiento)
      let fechaString = fecha.toLocaleString("es-MX",{ hour12: true })
      //console.log(fechaString)


      turf.featureEach(geojsonObject, function (currentFeature, featureIndex) {
        //console.log(currentFeature)
        let geojsonProperties = {}
        geojsonProperties["proyecto"] = that.currentPlace.proyecto_nombre;
        geojsonProperties["categoria"] = that.currentPlace.cat_principal_nombre; 
        geojsonProperties["subcategoria"] = that.currentPlace.cat_secundaria_nombre; 
        geojsonProperties["tipo"] = that.currentPlace.tipo_nombre; 
        geojsonProperties["descripcion"] = that.currentPlace.descripcion; 
        geojsonProperties["fecha"] = fechaString; 

/*         Object.entries(currentFeature.properties).forEach(([key, value]) => {
            console.log(key + ' ' + value);
            switch(key){
              case "projectInfo":
                geojsonProperties["proyecto"] = currentFeature.properties[key].nombre; 
                break;              
              case "categoryInfo":
                console.log("categoryInfo")
                geojsonProperties["categoria"] = currentFeature.properties[key].nombre; 
                break;
              case "subCategoryInfo":
                geojsonProperties["subcategoria"] = currentFeature.properties[key].nombre; 
                break; 
              case "typeInfo":
                geojsonProperties["tipo"] = currentFeature.properties[key].nombre; 
                break;
              case "privacidad": //no incluy eeste campo
                break;                
              default:
                geojsonProperties[key] = value; 
                break;
            }
        }); */

        let newFeature={
          type: "Feature",
          properties: geojsonProperties,
          geometry: currentFeature.geometry
        }

        geojsonExport.features.push(newFeature)
      });

      //console.log(JSON.stringify(geojsonExport))

      //var convertedData = 'text/json;charset=utf-8,' + encodeURIComponent(this.currentPlace.geojson);
      var convertedData = 'text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(geojsonExport)); //encodeURIComponent recibe el geojson como texto


      //console.log(convertedData) 
      const downloadLink = document.createElement('a');
      downloadLink.setAttribute('href', 'data:' + convertedData); 
      downloadLink.setAttribute('download', this.currentPlace.nombre+'.geojson');
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

    },

    toKMLFile(){
      console.log("toKMLFile")
      console.log(this.geojsonGeometries)

      //var kml = tokml(this.geojsonGeometries);
      var kml = tokml(JSON.parse(this.currentPlace.geojson)); //tokml recibe el geojson como objecto

      console.log(kml)
      var convertedData = 'application/xml;charset=utf-8,' + encodeURIComponent(kml);

      console.log(convertedData)
      // if you want to use the official MIME type for KML
      // var convertedData = 'application/vnd.google-earth.kml+xml;charset=utf-8,'+ 
      // encodeURIComponent(kml);
      const downloadLink = document.createElement('a');
      downloadLink.setAttribute('href', 'data:' + convertedData); 
      downloadLink.setAttribute('download', this.currentPlace.nombre+'.kml');
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },

    toSHPFile(){
      console.log("toSHPFile")

      // (optional) set names for feature types and zipped folder
      var options = {
          //folder: 'myshapes',
          folder: this.currentPlace.nombre,
          types: {
              point: 'puntos',
              polygon: 'polígonos',
              line: 'líneas'
          }
      }
      // a GeoJSON bridge for features
      shpwrite.download(JSON.parse(this.currentPlace.geojson), options) //shpwrite recibe el geojson como objeto

/*       shpwrite.download({
          type: 'FeatureCollection',
          features: [
              {
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: [0, 0]
                  },
                  properties: {
                      name: 'Foo'
                  }
              },
              {
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: [0, 10]
                  },
                  properties: {
                      name: 'Bar'
                  }
              }
          ]
      }, options); */
      // triggers a download of a zip file with shapefiles contained within.

    },

    safeZipName(name) {
      return name
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z0-9_]/g, '_')
    },

    async toSHPFileMultiple() {
      if (!this.selectedPlaces.length) {
        alert('No hay registros seleccionados')
        return
      }

      const selected = this.places.filter(
        p => this.selectedPlaces.includes(p.id) && p.geojson
      )

      if (!selected.length) {
        alert('No hay geojson válidos')
        return
      }

      const mainZip = new JSZip()

      for (const place of selected) {
        const options = {
          folder: this.safeZipName(place.nombre),
          types: {
            point: 'puntos',
            polygon: 'polígonos',
            line: 'líneas'
          },
          // pide preferentemente arraybuffer / blob si la lib lo soporta
          outputType: 'arraybuffer'
        }

        const geojson = typeof place.geojson === 'string' ? JSON.parse(place.geojson) : place.geojson

        // obtener zip interno (puede ser Blob, ArrayBuffer, Uint8Array, JSZip o Promise)
        let zipData
        if (typeof shpwrite.zip === 'function') {
          try {
            zipData = shpwrite.zip(geojson, options)
            if (zipData && typeof zipData.then === 'function') {
              zipData = await zipData
            }
          } catch (e) {
            console.error('shpwrite.zip falló para', place.nombre, e)
            continue
          }
        } else {
          console.error('shpwrite.zip no disponible en esta versión de shp-write')
          continue
        }

        // Normalizar zipData a Blob
        let blob = null
        try {
          // Si es instancia de JSZip (objeto con .files)
          if (zipData && typeof zipData === 'object' && zipData.files && typeof zipData.generateAsync === 'function') {
            const ab = await zipData.generateAsync({ type: 'arraybuffer' })
            blob = new Blob([ab], { type: 'application/zip' })
          } else if (zipData instanceof Blob) {
            blob = zipData
          } else if (zipData instanceof ArrayBuffer) {
            blob = new Blob([zipData], { type: 'application/zip' })
          } else if (ArrayBuffer.isView(zipData)) {
            // Uint8Array, etc.
            blob = new Blob([zipData.buffer], { type: 'application/zip' })
          } else if (typeof zipData === 'string') {
            // posible base64: intenta decodificar
            try {
              const bytes = atob(zipData)
              const len = bytes.length
              const u8 = new Uint8Array(len)
              for (let i = 0; i < len; i++) u8[i] = bytes.charCodeAt(i)
              blob = new Blob([u8.buffer], { type: 'application/zip' })
            } catch (err) {
              console.error('No se pudo convertir string zipData a Blob para', place.nombre, err)
            }
          } else {
            console.error('Tipo de zipData inesperado para', place.nombre, zipData)
          }
        } catch (err) {
          console.error('Error normalizando zip interno para', place.nombre, err)
        }

        if (!blob) {
          console.warn('No se pudo generar blob para', place.nombre, '- se omitirá')
          continue
        }

        // Añadir archivo zip interno como archivo binario (Blob) al ZIP principal
        mainZip.file(`${this.safeZipName(place.nombre)}.zip`, blob)
        this.selectedPlaces = []
      }

      try {
        const content = await mainZip.generateAsync({ type: 'blob' })
        saveAs(content, 'SHAPEFILES_MULTIPLES.zip')
      } catch (err) {
        console.error('Error generando ZIP principal:', err)
        alert('Error al generar el ZIP')
      }
    },



    formatDate(date) {
      return moment(date).format("DD/MM/YYYY hh:mm A");

      /* 	   let dateComplaint = new Date(date)
		var monthNames = [
		  "Enero", "Febrero", "Marzo",
		  "Abril", "Mayo", "Junio", "Julio",
		  "Agosto", "Septiembre", "Octubre",
		  "Noviembre", "Diciembre"
		];

		var day = dateComplaint.getDate();
		var monthIndex = dateComplaint.getMonth();
		var year = dateComplaint.getFullYear();

		return day + ' ' + monthNames[monthIndex] + ' ' + year;*/
    },
    formatExifDate(exifDate, mediaType) {
      let str = exifDate.split(" ");
      let dateStr = str[0].replace(/:/g, "-");
      let properDateStr = dateStr + " " + str[1];
      let dateExif = new Date(properDateStr);
      /*	  if(mediaType == "image")
		return moment(dateExif).format("DD/MM/YYYY hh:mm A");	*/
      if (mediaType == "video") {
        dateExif.setHours(dateExif.getHours() - 6); // corrige la horas si es video ??? -5 o -6 depende de horario de verano
      }
      return moment(dateExif).format("DD/MM/YYYY hh:mm A");
    },

    dateMediaFile(metadata, filetype) {
      //console.log(metadata)
      if (metadata != null) {
        switch (filetype) {
          case "image/jpeg":
            if (metadata.hasOwnProperty("createDate")) {
              //return metadata.modifyDate
              //console.log(metadata.createDate)
              return this.formatExifDate(metadata.createDate, "image");
            } else if (metadata.hasOwnProperty("modifyDate")) {
              //return metadata.modifyDate
              //console.log(metadata.modifyDate)
              return this.formatExifDate(metadata.modifyDate, "image");
            } else {
              //return "Fecha de la imagen no disponible (esto puede ser porque la imagen ha sido modificada u obtenida de internet)"
              return "Fecha de la imagen no disponible";
            }

            break;
          case "video/mp4":
            if (metadata.hasOwnProperty("mediaCreateDate")) {
              //return metadata.modifyDate
              //console.log(metadata.mediaCreateDate)
              return this.formatExifDate(metadata.mediaCreateDate, "video");
            } else if (metadata.hasOwnProperty("mediaModifyDate", "video")) {
              return this.formatExifDate(metadata.mediaModifyDate, "video");
            } else {
              //return "Fecha del video no disponible (esto puede ser porque el video ha sido modificado u obtenido de internet)"
              return "Fecha del video no disponible";
            }

            break;
          default:
            break;
        }
      } else {
        //return "Fecha de media no disponible (esto puede ser porque es modificado u obtenido de internet)"
        return "Fecha de media no disponible";
      }

      //return moment(date).format("DD/MM/YYYY hh:mm A");
    },
    mediaMetadata(metadata, filetype) {
      if (metadata == null) {
        switch (filetype) {
          case "image/jpeg":
            return "Metadatos de imagen no disponible";
            break;
          case "video/mp4":
            return "Metadatos de video no disponible";
            break;
          default:
            return "Metadatos de media no disponible";
            break;
        }
      } else {
        return JSON.stringify(metadata, null, 4); // Indented 4 spaces)
      }
    },

    datesDontMatch(complaintDate, ComplaintMetadata, filetype) {
      if (ComplaintMetadata != null) {
        let fechaDenuncia = this.formatDate(complaintDate);
        let fechaMedia = this.dateMediaFile(ComplaintMetadata, filetype);

        //console.log(fechaDenuncia)
        //console.log(fechaMedia)

        let fechaDenunciaArray = fechaDenuncia.split(" "); //separa fecha y hora
        let fechaMediaArray = fechaMedia.split(" ");

        if (fechaDenunciaArray[0] != fechaMediaArray[0]) {
          //compara sólo fecha
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },

    openMetadataModal() {
      this.showingMetadata = true;
    }        


  },
  computed: {
    filteredPlaces() {
      return this.places
        .filter(place => {
          return (
            
            (place.nombre.toLowerCase().includes(this.search.toLowerCase()) ||
              place.proyecto_nombre
                .toLowerCase()
                .includes(this.search.toLowerCase())) &&
            (this.categoryFilter === "-1" ||
              place.id_proyecto === this.categoryFilter.toString())
          );
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
              return -1;
            }
            if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
              return 1;
            }
            return 0;
          } else {
            if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
              return -1;
            }
            if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
              return 1;
            }
            return 0;
          }
        });
    },
  }
};
</script>

<style>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}

/* .leaflet-draw {
  margin-top: 10px !important;
  z-index: 10 !important;
}   */


.leaflet-marker-label {
  width: auto !important;
  height: auto !important;
}
</style>